import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import { EditorError } from "./types";

export type UseEditorMutationOptions<
  TData = unknown,
  TVariables = void,
  TContext = unknown,
> = UseMutationOptions<TData, EditorError, TVariables, TContext>;

export type UseEditorMutationResult<
  TData = unknown,
  TError = EditorError,
  TVariables = void,
  TContext = unknown,
> = UseMutationResult<TData, TError, TVariables, TContext>;

const useEditorMutation = <
  TData = unknown,
  TVariables = void,
  TContext = unknown,
>(
  options: UseEditorMutationOptions<TData, TVariables, TContext>,
): UseEditorMutationResult<TData, EditorError, TVariables, TContext> => {
  return useMutation(options);
};

export default useEditorMutation;
